import {IModalView} from "./IModalView";
import {DialogService, DynamicDialogRef} from "primeng/dynamicdialog";
import {IModalController, MK_MODAL_FLAG} from "../controllers/IModalController";
import {inject} from "@angular/core";
import {Helper} from "../helpers/Helper";

export abstract class AbstractModalView<ControllerType extends IModalController> implements IModalView<ControllerType> {

  private readonly controller: ControllerType|undefined|null;

  protected constructor(private dialogService: DialogService,
                        private dialogRef: DynamicDialogRef) {
    const data = this.getData();
    if(data && data['__controllerToken']) {
      this.controller = inject(data['__controllerToken']);
    }
  }

  getDialogService(): DialogService {
    return this.dialogService;
  }

  getDialogRef(): DynamicDialogRef {
    return this.dialogRef;
  }

  getData(): any {
    return this.dialogService.getInstance(this.dialogRef).data || {};
  }

  getController(): ControllerType {
    if(this.controller) {
      return this.controller;
    }
    else {
      throw new Error('No controller available');
    }
  }

  protected handle(eventName: string, eventData: any = {}): void {
    return this.getController().handle(eventName, eventData);
  }

  close(result?: any): void {
    const flagModel = this.getController().getModel(MK_MODAL_FLAG);

    setTimeout(() => {
      if(Helper.isValid(result)) {
        this.dialogRef.close(result);
      }
      else if(Helper.isValid(flagModel.result$())) {
        this.dialogRef.close(flagModel.result$());
      }
      else {
        this.dialogRef.close(result);
      }
    }, 0);
    // this.dialogRef.close(result);
  }
}
